export default from './current-user-avatar';



// WEBPACK FOOTER //
// ./app/containers/current-user-avatar/index.js